<template>
    <div class="col-12">
        <div class="row">
            <div class="col-12">
               <h4 class="headingLevel mb-4">
                <div class="custom-control custom-checkbox mb-1">
                    <input
                        type="checkbox"
                        :id="'show_date_perpetual_' + product.id"
                        v-model="leaseOptions.showPerpetualUpgrade"
                        @change="updateLeaseOptions($event)"
                        class="custom-control-input"
                    >
                    <label :for="'show_date_perpetual_' + product.id" class="custom-control-label d-flex flex-wrap" style="font-size: inherit; font-weight: inherit;">
                        {{ getTranslation('licence-configurator', 'upgrade_to_perpetual') }}
                    </label>
                </div>
                </h4>
            </div>
            <div
                :class="leaseOptions.showPerpetualUpgrade === true ? 'mb-4' : 'd-none'"
            >
                <div v-for="program in filteredPrograms" :key="program.id" class="col-12  ">
                    <div class="pl-5">
                        <div class="custom-checkbox b-custom-control-lg mb-4 " >
                            <span style="font-weight: 400;">{{ getProgramName(program.id, product.id) }}</span>
                            <b style="font-weight: 700;">{{ priceFormat(getProgramPrice(program.id, '', 'cloud_time_quantity', program.product, program.cloud_time_quantity * 3)) }}</b>
                        </div>
                    </div>
                </div>

                <div v-for="date in datesWithPerpetualUpgrade" :key="date" class="col-12  ">
                    <div class="pl-5">
                        <div class=" custom-checkbox b-custom-control-lg mb-4 " >
                            <span style="font-weight: 400;">{{ formatDateByLang(date) }} {{ getProgramText(date) }}</span>
                            <b style="font-weight: 700;">{{ priceFormat(getDatePrice(date)) }}</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
        methods: {
            updateLeaseOptions() {
                let self = this;

                _.forEach(this.filteredPrograms, function(p) {
                    let payload = {
                        id: p.id,
                        upgrade: self.leaseOptions.showPerpetualUpgrade,
                        column: 'perpetual_upgrade'
                    }
                    self.$store.commit('upgradeCartProgram', payload);
                });

                let payload = {
                    id: this.product.id,
                    data: this.leaseOptions,
                }

                if (this.leaseOptions.showPerpetualUpgrade) {
                    let allPrograms = _.filter(this.licences, function(l) { return (l.product == self.product.id && l.permanent_license == 0 && l.expired == false); });
                    //create
                    _.forEach(allPrograms, function (l) {
                        let payload = {
                            program_id: l.program_id,
                            discount: l.discount,
                            user_licence_id: l.user_licence_id,
                            leaseId: l.leaseId,
                            lease_end: l.lease_end,
                            product: l.product,
                            sort_order: l.sort_order,
                            quantity: l.quantity,
                        };
                        self.$store.commit('createLeasePerpetualUpgrade', payload);
                    });
                } else {
                    //delete
                    let payload = {
                        product: this.product.id,
                    };
                    this.$store.commit('deleteLeasePerpetualUpgrade', payload);
                }
                this.leasePerpetualUpgradeDates = [...new Set(this.$store.state.cart.perpetualUpgrade.map(item => item.lease_end))];

                this.$store.commit('updateLeaseOptions', payload);
            },
            upgradePerpetual(event, program) {
                let payload = {
                    id: program.id,
                    upgrade: event.target.checked,
                    column: 'perpetual_upgrade'
                }
                this.$store.commit('upgradeCartProgram', payload);
            },
            upgradePerpetualDate(event, date) {
                let self = this;
                let allPrograms = _.filter(this.licences, function(l) { return (l.lease_end == date && l.product == self.product.id && l.permanent_license == 0); });

                if (event.target.checked) {
                    //create
                    _.forEach(allPrograms, function (l) {
                        let payload = {
                            program_id: l.program_id,
                            discount: l.discount,
                            user_licence_id: l.user_licence_id,
                            leaseId: l.leaseId,
                            lease_end: l.lease_end,
                            product: l.product,
                            sort_order: l.sort_order,
                            quantity: l.quantity,
                        };
                        self.$store.commit('createLeasePerpetualUpgrade', payload);
                    });
                } else {
                    //delete
                    let payload = {
                        product: this.product.id,
                        lease_end: date,
                    };
                    this.$store.commit('deleteLeasePerpetualUpgrade', payload);
                }
            },
            getDatePrice(date) {
                let self = this;
                let allPrograms = _.filter(this.licences, function(l) { return (l.lease_end == date && l.product == self.product.id && l.permanent_license == 0); });

                let total = 0;

                _.forEach(allPrograms, function (p) {
                    total += self.getProgramPrice(p.program_id, '', 'cloud_time_quantity', p.product, p.quantity * 3)
                });

                return total;
            },

            getProgramText(date) {
                let self = this;
                let allPrograms = _.filter(this.licences, function(l) { return (l.lease_end == date && l.product == self.product.id && l.permanent_license == 0); });
                let programs = _.uniqBy(allPrograms, 'program_id');


                let pr = [];
                _.forEach(programs, function (p) {
                    let name = p.program_name;

                    let totalQty = _.sumBy(allPrograms, (item) => {
                        return item.program_id === p.program_id ? item.quantity : 0;
                    });

                    if (totalQty > 1) {
                        name = totalQty + 'x '  + p.program_name;
                    }
                    pr.push(name);
                })
                return pr.join(", ");
            },
            compareDates(date1, date2) {
                if (date1 === date2) {
                    return 0;
                } else if (this.daysBetween(date1, date2) > 0) {
                    return 1
                } else {
                    return -1;
                }
            },
            getFormattedDate(date = false) {
                if (date === false) {
                    date = new Date();
                }
                let year = date.getFullYear();
                // Month is 0-indexed, so add 1
                let month = String(date.getMonth() + 1).padStart(2, '0');
                let day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
            daysBetween(startDate, endDate) {
                let millisecondsPerDay = 24 * 60 * 60 * 1000;
                let ret = (this.treatAsUTC(endDate) - this.treatAsUTC(startDate)) / millisecondsPerDay;
                return Math.ceil(ret);
            },
            treatAsUTC(date) {
                return new Date(date);
                //result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
                // return result;
            },
        },
        beforeMount() {
            this.leaseOptions = this.$store.state.cart.leaseOptions[this.product.id];
            this.leasePerpetualUpgradeDates = [...new Set(this.$store.state.cart.perpetualUpgrade.map(item => item.lease_end))];

            if (this.$store.state.cart.leaseOptions && this.$store.state.cart.leaseOptions[this.product.id]) {
                this.leaseOptions = this.$store.state.cart.leaseOptions[this.product.id];
            } else {
                this.leaseOptions = {
                    showPerpetualUpgrade: false,
                };
            }

            if (this.$store.state.cart.perpetualUpgrade) {
                this.leasePerpetualUpgradeDates = [...new Set(this.$store.state.cart.perpetualUpgrade.map(item => item.lease_end))];
            }

        },
        mounted() {

        },
        computed: {
            filteredPrograms() {
                return this.$store.state.cart.programs.filter(program => program.product == this.product.id);
            },
            datesWithPerpetualUpgrade() {
                let self = this;

                let filtered = _.filter(this.licences, function(l) { return (
                    l.permanent_license == 0 && l.product == self.product.id
                    && self.compareDates(self.getFormattedDate(), l.lease_end) > 0
                ) });
                let dates = [];
                if (filtered.length > 0) {
                    dates = [...new Set(filtered.map(item => item.lease_end))];
                }
                return dates;
            }
        },
        data() {
            return {
                products: window.jsonProducts,
                leaseOptions: {},
                leasePerpetualUpgradeDates: [],
                licences: JSON.parse(window.licences),
            };
        },
        props: {
            product: Object,
        }
    }
</script>
